import { computed } from 'vue'

import { IncidentId } from '@collector/sportsapi-client-legacy'

import { useSwappableIncidentsQuery } from './queries/useSwappableIncidentsQuery'

export const useSwappableIncidents = () => {
  const { data } = useSwappableIncidentsQuery()

  const swappableIncidents = computed(() => data.value ?? {})
  const swappableIncidentsId = computed(
    () => Object.keys(swappableIncidents.value).map(Number) as IncidentId[],
  )

  return {
    swappableIncidents,
    swappableIncidentsId,
  }
}
